module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wbx_home"
  }, [_c('div', {
    staticClass: "weui-fp"
  }, [(_vm.dataDetail.invoiceBaseInfo.invoiceKind === '10') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/fp2.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '04') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/fp22.png")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.dataDetail.invoiceBaseInfo.invoiceKind === '01') ? _c('div', {
    staticClass: "fp_logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/zhuanyong.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fpnr"
  }, [_c('p', [_c('label', [_vm._v("发票代码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceCode))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("发票号码")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceNo))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("开票日期")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateFilter")(_vm.dataDetail.invoiceBaseInfo.invoiceDate, 'yyyy-MM-dd')))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("不含税金额")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.dataDetail.invoiceBaseInfo.invoiceAmount))])]), _vm._v(" "), _c('p', [_c('label', [_vm._v("发票种类")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "sczp"
  }, [_c('label', {
    staticClass: "weui_label"
  }, [_vm._v("上传照片")]), _vm._v(" "), _c('p', [_c('span', {
    on: {
      "click": _vm.uploadImg
    }
  }, [_c('img', {
    attrs: {
      "slot": "icon",
      "width": "57px",
      "height": "57",
      "src": require("../../assets/img/img_add.jpg")
    },
    slot: "icon"
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "display": "inline"
    }
  }, _vm._l((_vm.localIds), function(item, index) {
    return _c('span', [_c('img', {
      attrs: {
        "slot": "icon",
        "width": "57px",
        "height": "57",
        "src": item
      },
      slot: "icon"
    }), _c('sup', {
      staticStyle: {
        "position": "absolute",
        "top": "0px",
        "right": "5px",
        "z-index": "101"
      }
    }, [_c('font', {
      staticClass: "vux-badge vux-badge-single",
      on: {
        "click": function($event) {
          return _vm.deleteImg(index)
        }
      }
    }, [_vm._v("X")])], 1)])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "queding"
  }, [_c('x-button', {
    staticClass: "btn-new-sty",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save.apply(null, arguments)
      }
    }
  }, [_vm._v("保存图片")])], 1), _vm._v(" "), _c('alert', {
    model: {
      value: (_vm.warnMsgShow),
      callback: function($$v) {
        _vm.warnMsgShow = $$v
      },
      expression: "warnMsgShow"
    }
  }, [_vm._v(_vm._s(_vm.warnMsg))]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": "3000"
    },
    model: {
      value: (_vm.toastShow),
      callback: function($$v) {
        _vm.toastShow = $$v
      },
      expression: "toastShow"
    }
  }, [_vm._v(_vm._s(_vm.toastMsg))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('loading', {
    attrs: {
      "text": _vm.loadingText
    },
    model: {
      value: (_vm.loadingShow),
      callback: function($$v) {
        _vm.loadingShow = $$v
      },
      expression: "loadingShow"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32f11fe5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fpj/scptfp.vue
// module id = 329
// module chunks = 0